<template>
  <div class="table">
    <table v-if="!isMobile">
      <tr>
        <th class="column-header" />
        <th
          v-for="(column, columnIndex) in columns"
          :key="columnIndex"
          class="column-header"
        >
          <div class="column-title">
            {{ column.title }}
          </div>
          <div class="column-subtitle">
            {{ column.subtitle }}
          </div>
        </th>
      </tr>
      <template v-for="(table, tableIndex) in tables">
        <tr
          :key="tableIndex"
          :class="{'first-title-row': tableIndex === 0}"
        >
          <td
            v-dompurify-html="table.title"
            :colspan="columnCount"
            class="table-title"
          />
        </tr>
        <tr
          v-for="(row, rowIndex) in getTableData(table)"
          :key="rowIndex"
          class="table-row"
        >
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            v-dompurify-html="cell"
            :class="['cell', {'row-title': cellIndex === 0}]"
            :style="{ 'width': 'calc(100% / ' + columnCount + ')' }"
          />
        </tr>
      </template>
    </table>

    <template v-if="isMobile">
      <div
        v-for="(table, tableIndex) in tables"
        :key="tableIndex"
      >
        <div
          v-dompurify-html="table.title"
          class="table-title"
        />
        <div
          v-for="(row, rowIndex) in getTableData(table)"
          :key="rowIndex"
          class="table-row"
        >
          <div
            v-dompurify-html="row[0]"
            class="row-title"
          />
          <div
            v-for="(column, columnIndex) in columns"
            :key="columnIndex"
          >
            <div
              v-dompurify-html="column.title"
              class="column-title"
            />
            <div
              v-dompurify-html="row[columnIndex + 1]"
              class="cell"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      tables: {
        type: Array,
        default: () => []
      },
      columns: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      columnCount () {
        return this.columns.length + 1
      },

      ...mapGetters('device', [
        'isMobile'
      ])
    },

    methods: {
      getTableData (table) {
        if (!table.tableData || !table.tableData.length) {
          return []
        }
        return JSON.parse(table.tableData)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .table /deep/ {
    white-space: pre-line;

    a {
      color: $blue-medium;

      &:hover {
        color: $blue-light;
      }
    }

    p {
      margin: 0;
    }
  }

  table {
    width: 100%;
    margin-top: 40px;

    .cell {
      padding: 10px 16px;
    }

    .table-title {
      border-top: 24px solid #ffffff;
    }

    .first-title-row {

      .table-title {
        border-top: 12px solid #ffffff;
      }
    }
  }

  .column-header {
    background-color: $gray-yellow;

    @include bp-mf-tablet {
      text-align: left;
    }

    .column-title {
      padding: 16px 16px 3px;
      color: $blue-dark;
      font-size: em(16);
    }

    .column-subtitle {
      padding: 0 16px 13px;
      color: $grey;
      font-weight: 400;
    }
  }

  .table-title {
    min-height: 40px;
    height: auto;
    padding: 10px 24px;
    line-height: 20px;
    white-space: normal;
    font-size: em(14);
    font-weight: 500;
    background-color: #E8ECD0;
    color: $blue-dark;
    word-wrap: break-word;

    @include bp-mf-tablet {
      padding: 10px 16px;
      line-height: 20px;
      font-size: em(12);
    }
  }

  .table-row {
    padding: 24px;

    &:nth-child(2n) {
      background-color: $table-gray-background;
    }
  }

  .row-title {
    font-size: em(16);
    font-weight: 500;

    @include bp-mf-tablet {
      font-size: em(14);
    }
  }

  .column-title {
    padding: 16px 0 8px;
    font-weight: 500;
    color: $grey;
  }

</style>
